import * as Types from '../../../generated/graphql_types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type NucleusDatasetListQueryVariables = Types.Exact<{
  limit: Types.InputMaybe<Types.Scalars['Int']>;
  offset: Types.InputMaybe<Types.Scalars['Int']>;
  query: Types.InputMaybe<Types.Scalars['String']>;
  privacyType: Types.InputMaybe<
    | ReadonlyArray<Types.InputMaybe<Types.Scalars['String']>>
    | Types.InputMaybe<Types.Scalars['String']>
  >;
  tags: Types.InputMaybe<ReadonlyArray<Types.Scalars['String']> | Types.Scalars['String']>;
}>;

export type NucleusDatasetListQuery = {
  readonly __typename?: 'RootQuery';
  readonly nucleusDatasetsCount: number;
  readonly viewer: { readonly __typename: 'ScaleUser'; readonly id: string } | null;
  readonly nucleusDatasets: ReadonlyArray<{
    readonly __typename: 'NucleusDataset';
    readonly id: string;
    readonly sliceCount: number | null;
    readonly tags: ReadonlyArray<string>;
    readonly name: string;
    readonly created_at: string;
    readonly delete_status: Types.DatasetDeleteStatus | null;
    readonly is_public: boolean;
    readonly is_scene: boolean;
    readonly is_label_linked: boolean | null;
    readonly rapid_project_id: string | null;
    readonly self_serve_project_id: string | null;
    readonly invalid_task_types: ReadonlyArray<string> | null;
    readonly license_id: string | null;
    readonly viewer_is_owner: boolean | null;
    readonly user: {
      readonly __typename: 'ScaleUser';
      readonly id: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly email: string | null;
    } | null;
    readonly cover_item: {
      readonly __typename: 'NucleusDatasetItem';
      readonly id: string;
      readonly processed_image_url_grid: string | null;
    } | null;
    readonly pending_jobs: ReadonlyArray<{
      readonly __typename: 'NucleusJob';
      readonly id: string;
      readonly job_type: string | null;
    }> | null;
  }>;
};

export type NucleusDatasetNameListQueryVariables = Types.Exact<{
  privacyType: Types.InputMaybe<
    | ReadonlyArray<Types.InputMaybe<Types.Scalars['String']>>
    | Types.InputMaybe<Types.Scalars['String']>
  >;
}>;

export type NucleusDatasetNameListQuery = {
  readonly __typename?: 'RootQuery';
  readonly nucleusDatasets: ReadonlyArray<{
    readonly __typename: 'NucleusDataset';
    readonly id: string;
    readonly name: string;
  }>;
};

export type NucleusAllDatasetNamesAndModelRunsQueryVariables = Types.Exact<{
  privacyType: Types.InputMaybe<
    | ReadonlyArray<Types.InputMaybe<Types.Scalars['String']>>
    | Types.InputMaybe<Types.Scalars['String']>
  >;
}>;

export type NucleusAllDatasetNamesAndModelRunsQuery = {
  readonly __typename?: 'RootQuery';
  readonly nucleusDatasets: ReadonlyArray<{
    readonly __typename: 'NucleusDataset';
    readonly id: string;
    readonly name: string;
    readonly type: Types.DatasetTypeEnum;
    readonly is_public: boolean;
    readonly is_scene: boolean;
    readonly viewer_is_owner: boolean | null;
    readonly model_runs: ReadonlyArray<{
      readonly __typename: 'NucleusModelRun';
      readonly id: string;
      readonly status: string | null;
    }> | null;
  }>;
};

export type NucleusDatasetItemCountListQueryVariables = Types.Exact<{
  privacyType: Types.InputMaybe<
    | ReadonlyArray<Types.InputMaybe<Types.Scalars['String']>>
    | Types.InputMaybe<Types.Scalars['String']>
  >;
}>;

export type NucleusDatasetItemCountListQuery = {
  readonly __typename?: 'RootQuery';
  readonly nucleusDatasets: ReadonlyArray<{
    readonly __typename: 'NucleusDataset';
    readonly id: string;
    readonly itemCount: number | null;
  }>;
};

export type NucleusDatasetListLinkedProjectsQueryVariables = Types.Exact<{
  limit: Types.InputMaybe<Types.Scalars['Int']>;
  offset: Types.InputMaybe<Types.Scalars['Int']>;
  query: Types.InputMaybe<Types.Scalars['String']>;
  privacyType: Types.InputMaybe<
    | ReadonlyArray<Types.InputMaybe<Types.Scalars['String']>>
    | Types.InputMaybe<Types.Scalars['String']>
  >;
  tags: Types.InputMaybe<ReadonlyArray<Types.Scalars['String']> | Types.Scalars['String']>;
}>;

export type NucleusDatasetListLinkedProjectsQuery = {
  readonly __typename?: 'RootQuery';
  readonly nucleusDatasets: ReadonlyArray<{
    readonly __typename: 'NucleusDataset';
    readonly id: string;
    readonly linkedProjects: ReadonlyArray<{
      readonly __typename: 'NucleusDatasetLinkedProject';
      readonly projectId: string;
      readonly projectType: Types.ProjectType;
      readonly taskType: Types.TaskType;
      readonly name: string;
    } | null> | null;
  }>;
};

export type NucleusDatasetListByIdsQueryVariables = Types.Exact<{
  ids: ReadonlyArray<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;

export type NucleusDatasetListByIdsQuery = {
  readonly __typename?: 'RootQuery';
  readonly nucleusDatasetByIds: ReadonlyArray<{
    readonly __typename: 'NucleusDataset';
    readonly id: string;
    readonly sliceCount: number | null;
    readonly tags: ReadonlyArray<string>;
    readonly name: string;
    readonly created_at: string;
    readonly delete_status: Types.DatasetDeleteStatus | null;
    readonly is_public: boolean;
    readonly is_scene: boolean;
    readonly is_label_linked: boolean | null;
    readonly rapid_project_id: string | null;
    readonly self_serve_project_id: string | null;
    readonly invalid_task_types: ReadonlyArray<string> | null;
    readonly license_id: string | null;
    readonly viewer_is_owner: boolean | null;
    readonly user: {
      readonly __typename: 'ScaleUser';
      readonly id: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly email: string | null;
    } | null;
    readonly cover_item: {
      readonly __typename: 'NucleusDatasetItem';
      readonly id: string;
      readonly processed_image_url_grid: string | null;
    } | null;
    readonly pending_jobs: ReadonlyArray<{
      readonly __typename: 'NucleusJob';
      readonly id: string;
      readonly job_type: string | null;
    }> | null;
  }>;
};

export type NucleusDatasetItemCountListByIdsQueryVariables = Types.Exact<{
  ids: ReadonlyArray<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;

export type NucleusDatasetItemCountListByIdsQuery = {
  readonly __typename?: 'RootQuery';
  readonly nucleusDatasetByIds: ReadonlyArray<{
    readonly __typename: 'NucleusDataset';
    readonly id: string;
    readonly itemCount: number | null;
  }>;
};

export type NucleusDatasetItemLinkedProjectByIdsQueryVariables = Types.Exact<{
  ids: ReadonlyArray<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;

export type NucleusDatasetItemLinkedProjectByIdsQuery = {
  readonly __typename?: 'RootQuery';
  readonly nucleusDatasetByIds: ReadonlyArray<{
    readonly __typename: 'NucleusDataset';
    readonly id: string;
    readonly linkedProjects: ReadonlyArray<{
      readonly __typename: 'NucleusDatasetLinkedProject';
      readonly projectId: string;
      readonly projectType: Types.ProjectType;
      readonly taskType: Types.TaskType;
      readonly name: string;
    } | null> | null;
  }>;
};

export type NucleusDatasetTagsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type NucleusDatasetTagsQuery = {
  readonly __typename?: 'RootQuery';
  readonly nucleusDatasetTags: ReadonlyArray<string>;
};

export type DatasetMinimumInfoFragment = {
  readonly __typename: 'NucleusDataset';
  readonly id: string;
  readonly name: string;
  readonly type: Types.DatasetTypeEnum;
  readonly is_public: boolean;
  readonly is_scene: boolean;
  readonly viewer_is_owner: boolean | null;
  readonly model_runs: ReadonlyArray<{
    readonly __typename: 'NucleusModelRun';
    readonly id: string;
    readonly status: string | null;
  }> | null;
};

export type ModelRunMinimumInfoFragment = {
  readonly __typename: 'NucleusModelRun';
  readonly id: string;
  readonly status: string | null;
};

export type DatasetListFieldsFragment = {
  readonly __typename: 'NucleusDataset';
  readonly id: string;
  readonly sliceCount: number | null;
  readonly tags: ReadonlyArray<string>;
  readonly name: string;
  readonly created_at: string;
  readonly delete_status: Types.DatasetDeleteStatus | null;
  readonly is_public: boolean;
  readonly is_scene: boolean;
  readonly is_label_linked: boolean | null;
  readonly rapid_project_id: string | null;
  readonly self_serve_project_id: string | null;
  readonly invalid_task_types: ReadonlyArray<string> | null;
  readonly license_id: string | null;
  readonly viewer_is_owner: boolean | null;
  readonly user: {
    readonly __typename: 'ScaleUser';
    readonly id: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly email: string | null;
  } | null;
  readonly cover_item: {
    readonly __typename: 'NucleusDatasetItem';
    readonly id: string;
    readonly processed_image_url_grid: string | null;
  } | null;
  readonly pending_jobs: ReadonlyArray<{
    readonly __typename: 'NucleusJob';
    readonly id: string;
    readonly job_type: string | null;
  }> | null;
};

export type DatasetListInfoFragment = {
  readonly __typename: 'NucleusDataset';
  readonly id: string;
  readonly name: string;
  readonly created_at: string;
  readonly delete_status: Types.DatasetDeleteStatus | null;
  readonly is_public: boolean;
  readonly is_scene: boolean;
  readonly is_label_linked: boolean | null;
  readonly rapid_project_id: string | null;
  readonly self_serve_project_id: string | null;
  readonly invalid_task_types: ReadonlyArray<string> | null;
  readonly license_id: string | null;
  readonly viewer_is_owner: boolean | null;
  readonly pending_jobs: ReadonlyArray<{
    readonly __typename: 'NucleusJob';
    readonly id: string;
    readonly job_type: string | null;
  }> | null;
};

export type LinkedProjectsFragmentFragment = {
  readonly __typename: 'NucleusDatasetLinkedProject';
  readonly projectId: string;
  readonly projectType: Types.ProjectType;
  readonly taskType: Types.TaskType;
  readonly name: string;
};

export const ModelRunMinimumInfoFragmentDoc = gql`
  fragment modelRunMinimumInfo on NucleusModelRun {
    __typename
    id
    status
  }
`;
export const DatasetMinimumInfoFragmentDoc = gql`
  fragment datasetMinimumInfo on NucleusDataset {
    __typename
    id
    name
    type
    is_public
    is_scene
    viewer_is_owner
    model_runs {
      ...modelRunMinimumInfo
    }
  }
  ${ModelRunMinimumInfoFragmentDoc}
`;
export const DatasetListInfoFragmentDoc = gql`
  fragment datasetListInfo on NucleusDataset {
    __typename
    id
    name
    created_at
    delete_status
    is_public
    is_scene
    is_label_linked
    rapid_project_id
    self_serve_project_id
    invalid_task_types
    license_id
    viewer_is_owner
    pending_jobs {
      __typename
      id
      job_type
    }
  }
`;
export const DatasetListFieldsFragmentDoc = gql`
  fragment datasetListFields on NucleusDataset {
    __typename
    id
    ...datasetListInfo
    user {
      __typename
      id
      firstName
      lastName
      email
    }
    cover_item {
      __typename
      id
      processed_image_url_grid
    }
    sliceCount
    tags
  }
  ${DatasetListInfoFragmentDoc}
`;
export const LinkedProjectsFragmentFragmentDoc = gql`
  fragment linkedProjectsFragment on NucleusDatasetLinkedProject {
    __typename
    projectId
    projectType
    taskType
    name
  }
`;
export const NucleusDatasetListDocument = gql`
  query NucleusDatasetList(
    $limit: Int
    $offset: Int
    $query: String
    $privacyType: [String]
    $tags: [String!]
  ) {
    viewer {
      __typename
      id
    }
    nucleusDatasets(
      offset: $offset
      limit: $limit
      query: $query
      privacyType: $privacyType
      tags: $tags
    ) {
      ...datasetListFields
    }
    nucleusDatasetsCount(query: $query, privacyType: $privacyType, tags: $tags)
  }
  ${DatasetListFieldsFragmentDoc}
`;

export function useNucleusDatasetListQuery(
  options?: Omit<Urql.UseQueryArgs<NucleusDatasetListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<NucleusDatasetListQuery, NucleusDatasetListQueryVariables>({
    query: NucleusDatasetListDocument,
    ...options,
  });
}
export const NucleusDatasetNameListDocument = gql`
  query NucleusDatasetNameList($privacyType: [String]) {
    nucleusDatasets(privacyType: $privacyType) {
      __typename
      id
      name
    }
  }
`;

export function useNucleusDatasetNameListQuery(
  options?: Omit<Urql.UseQueryArgs<NucleusDatasetNameListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<NucleusDatasetNameListQuery, NucleusDatasetNameListQueryVariables>({
    query: NucleusDatasetNameListDocument,
    ...options,
  });
}
export const NucleusAllDatasetNamesAndModelRunsDocument = gql`
  query NucleusAllDatasetNamesAndModelRuns($privacyType: [String]) {
    nucleusDatasets(privacyType: $privacyType) {
      ...datasetMinimumInfo
    }
  }
  ${DatasetMinimumInfoFragmentDoc}
`;

export function useNucleusAllDatasetNamesAndModelRunsQuery(
  options?: Omit<Urql.UseQueryArgs<NucleusAllDatasetNamesAndModelRunsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    NucleusAllDatasetNamesAndModelRunsQuery,
    NucleusAllDatasetNamesAndModelRunsQueryVariables
  >({ query: NucleusAllDatasetNamesAndModelRunsDocument, ...options });
}
export const NucleusDatasetItemCountListDocument = gql`
  query NucleusDatasetItemCountList($privacyType: [String]) {
    nucleusDatasets(privacyType: $privacyType) {
      __typename
      id
      itemCount
    }
  }
`;

export function useNucleusDatasetItemCountListQuery(
  options?: Omit<Urql.UseQueryArgs<NucleusDatasetItemCountListQueryVariables>, 'query'>,
) {
  return Urql.useQuery<NucleusDatasetItemCountListQuery, NucleusDatasetItemCountListQueryVariables>(
    { query: NucleusDatasetItemCountListDocument, ...options },
  );
}
export const NucleusDatasetListLinkedProjectsDocument = gql`
  query NucleusDatasetListLinkedProjects(
    $limit: Int
    $offset: Int
    $query: String
    $privacyType: [String]
    $tags: [String!]
  ) {
    nucleusDatasets(
      offset: $offset
      limit: $limit
      query: $query
      privacyType: $privacyType
      tags: $tags
    ) {
      __typename
      id
      linkedProjects {
        ...linkedProjectsFragment
      }
    }
  }
  ${LinkedProjectsFragmentFragmentDoc}
`;

export function useNucleusDatasetListLinkedProjectsQuery(
  options?: Omit<Urql.UseQueryArgs<NucleusDatasetListLinkedProjectsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    NucleusDatasetListLinkedProjectsQuery,
    NucleusDatasetListLinkedProjectsQueryVariables
  >({ query: NucleusDatasetListLinkedProjectsDocument, ...options });
}
export const NucleusDatasetListByIdsDocument = gql`
  query NucleusDatasetListByIds($ids: [ID!]!) {
    nucleusDatasetByIds(ids: $ids) {
      ...datasetListFields
    }
  }
  ${DatasetListFieldsFragmentDoc}
`;

export function useNucleusDatasetListByIdsQuery(
  options: Omit<Urql.UseQueryArgs<NucleusDatasetListByIdsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<NucleusDatasetListByIdsQuery, NucleusDatasetListByIdsQueryVariables>({
    query: NucleusDatasetListByIdsDocument,
    ...options,
  });
}
export const NucleusDatasetItemCountListByIdsDocument = gql`
  query NucleusDatasetItemCountListByIds($ids: [ID!]!) {
    nucleusDatasetByIds(ids: $ids) {
      __typename
      id
      itemCount
    }
  }
`;

export function useNucleusDatasetItemCountListByIdsQuery(
  options: Omit<Urql.UseQueryArgs<NucleusDatasetItemCountListByIdsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    NucleusDatasetItemCountListByIdsQuery,
    NucleusDatasetItemCountListByIdsQueryVariables
  >({ query: NucleusDatasetItemCountListByIdsDocument, ...options });
}
export const NucleusDatasetItemLinkedProjectByIdsDocument = gql`
  query NucleusDatasetItemLinkedProjectByIds($ids: [ID!]!) {
    nucleusDatasetByIds(ids: $ids) {
      __typename
      id
      linkedProjects {
        ...linkedProjectsFragment
      }
    }
  }
  ${LinkedProjectsFragmentFragmentDoc}
`;

export function useNucleusDatasetItemLinkedProjectByIdsQuery(
  options: Omit<Urql.UseQueryArgs<NucleusDatasetItemLinkedProjectByIdsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    NucleusDatasetItemLinkedProjectByIdsQuery,
    NucleusDatasetItemLinkedProjectByIdsQueryVariables
  >({ query: NucleusDatasetItemLinkedProjectByIdsDocument, ...options });
}
export const NucleusDatasetTagsDocument = gql`
  query NucleusDatasetTags {
    nucleusDatasetTags
  }
`;

export function useNucleusDatasetTagsQuery(
  options?: Omit<Urql.UseQueryArgs<NucleusDatasetTagsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<NucleusDatasetTagsQuery, NucleusDatasetTagsQueryVariables>({
    query: NucleusDatasetTagsDocument,
    ...options,
  });
}
